<template>
  <div v-if="clickLimit >= 0" class="invite-wrap">
    <form
      id="invite"
      v-if="!formSuccess"
      @submit="checkForm"
      action="#"
      method="post"
      novalidate="true"
    >
      <table id="inviteForm" class="inviteForm">
        <caption class="caption">
          Member invite form list
        </caption>
        <tr class="header">
          <th class="email" scope="col">
            <label class="email" for="email"
              >{{ $t("group.memberInviteForm.modal.text.email") }}&emsp;&emsp;{{
                $t("plan.inviteForm.modal.invitationsLeft")
              }}: <span class="error">{{ invitationsLeft }}</span></label
            >
          </th>
          <th class="role" scope="col">
            <label class="role" for="role">{{
              $t("group.memberInviteForm.modal.text.role")
            }}</label>
          </th>
        </tr>
        <tr
          class="input-wrapper"
          v-for="(email, index) in emails"
          v-bind:key="index"
        >
          <td>
            <input
              v-bind:class="{
                error: emails[index].error,
                email: true,
                errorInput: emails[index].error,
              }"
              v-bind:id="'email-' + index"
              v-bind:name="'email' + index"
              v-model="emails[index].email"
              v-bind:placeholder="$t('group.memberInviteForm.placeholder')"
              v-on:input="emails[index].error = false"
            />
            <p class="error errorMsg" v-if="emails[index].error">
              {{
                email.email.length > 0
                  ? $t("group.memberInviteForm.errorMsg.invalidEmail")
                  : $t("group.memberInviteForm.errorMsg.noEmail")
              }}
            </p>
          </td>
          <td>
            <select
              class="role"
              v-bind:id="'role-' + index"
              v-bind:name="'role' + index"
              v-model="emails[index].role"
            >
              <option
                v-for="(option, oIdx) in options"
                v-bind:value="option.value"
                >{{ option.text }}</option
              >
            </select>
          </td>
          <td>
            <div
              v-if="index + 1 === emails.length && clickLimit > 0"
              class="add action"
              @click="addField"
            ></div>
            <div
              v-else-if="index + 1 === emails.length && clickLimit <= 0"
              class="blank action"
            ></div>
            <div
              v-if="index + 1 < emails.length"
              class="remove action"
              @click="removeField(index)"
            ></div>
          </td>
        </tr>

        <input
          type="submit"
          class="submit"
          v-bind:value="$t('group.memberInviteForm.modal.button')"
        />
      </table>
    </form>
    <div v-if="formSuccess" class="success-message">
      <h3>{{ $t("group.memberInviteForm.infoMsg") }}:</h3>
      <ul>
        <li v-for="(email, idx) in emails" v-bind:key="idx">
          {{ email.email }}
        </li>
      </ul>
    </div>
  </div>
  <div v-else-if="clickLimit < 0">
    <h3>{{ $t("group.memberInviteForm.modal.limitMsg") }}</h3>
    <br />
  </div>
</template>

<script>
import { validEmail } from "@/utils/validEmail";
import { groupService } from "@/services/group.service";

export default {
  name: "GroupInviteForm",
  props: ["groupId", "invitationsLeft", "clickLimit"],
  data: function() {
    return {
      formErrors: false,
      formSuccess: false,
      options: [
        { text: this.$t("group.memberInviteForm.select.item01"), value: 0 },
        { text: this.$t("group.memberInviteForm.select.item02"), value: 1 },
      ],
      emails: [
        {
          email: "",
          role: 0,
          error: false,
        },
      ],
    };
  },
  methods: {
    addField: function() {
      this.emails.push({ email: "", role: 0, error: false });
      this.clickLimit -= 1;
    },
    removeField: function(idx) {
      this.emails.splice(idx, 1);
      this.clickLimit += 1;
    },
    checkForm: function(event) {
      this.formErrors = false;
      const newEmails = [];

      for (let i = 0; i < this.emails.length; i++) {
        if (!this.emails[i].email && this.emails.length > 1) {
          continue;
        } else if (!validEmail(this.emails[i].email)) {
          this.formErrors = true;
          newEmails.push({
            email: this.emails[i].email,
            role: this.emails[i].role,
            error: true,
          });
        } else {
          newEmails.push({
            email: this.emails[i].email,
            role: this.emails[i].role,
            error: false,
          });
        }
      }

      if (newEmails.length > 0) {
        this.emails = newEmails;
      } else {
        this.formErrors = true;
        this.emails = [
          {
            email: "",
            role: 0,
            error: true,
          },
        ];
      }

      this.clickLimit = this.invitationsLeft - this.emails.length;

      if (!this.formErrors) {
        this.sendInvites();
      }

      event.preventDefault();
    },
    sendInvites: function() {
      if (this.groupId) {
        for (let i = 0; i < this.emails.length; i++) {
          groupService
            .createInvitation(
              this.groupId,
              this.emails[i].email,
              this.emails[i].role === 1 ? true : false
            )
            .then((resp) => {
              if (resp.ok) {
                this.formSuccess = true;
                //this.$emit('close-modal')
              }
            });
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#invite {
  .input-wrapper {
    align-items: center;
    margin-bottom: 23px;
  }

  table {
    width: 100%;
    .caption {
      display: none;
    }
  }

  td {
    background: $surface-alpha;
    color: $text-dark;
    padding: 0;
  }

  tr.header {
    background: $surface-alpha;
    color: $text-dark;
    th {
      text-align: left;
      border: none;
      padding: 7px 0 7px 5px;
    }
  }

  input.email {
    flex: 2 1 auto;
    margin: 0 12px 20px 0;
    font-size: small;
    width: 97%;
  }

  select {
    flex: 0 1 auto;
    margin: 0 12px 20px 0;
    background: none;
  }

  .action {
    flex: 1 0 24px;
    margin: 0 0 20px 10px;
    width: 24px;
    height: 24px;
  }
  .add {
    background: url("../../assets/icons/add.png") no-repeat center center;
  }
  .remove {
    background: url("../../assets/icons/remove.png") no-repeat center center;
  }
  .blank {
    background: none no-repeat center center;
  }

  input.submit {
    margin: 0 0 40px;
    width: auto;
  }
}

.success-message {
  margin: 0 40px;
  ul {
    li {
      list-style: inside;
      display: list-item;
      padding: 5px 0;
    }
  }
}
.errorInput {
  margin-top: 14px !important;
}
.errorMsg {
  margin-top: -20px;
}
</style>
